// Tldraw ships its UI icons as one merged SVG sprite on its CDN. Pin the URL to
// the installed tldraw version (keep in sync with package.json — currently
// 4.5.x) so the icon set matches the bundled components; a stale pin can
// silently diverge and render blank buttons.
export const TLDRAW_ICON_SPRITE =
  "https://cdn.tldraw.com/4.5.12/icons/icon/0_merged.svg";

/** CSS `mask-image` URL for a named icon in the sprite. */
export const tldrawIconMask = (name: string): string =>
  `url('${TLDRAW_ICON_SPRITE}#${name}')`;
